import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article8() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';

      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article9');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article7');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article8-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article8-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <motion.div variants={textAnimate}>

              <h1 className="fs-xl f-lora mb-2">Cast Iron Cullen <br/><span className="f-lora-i">Skink with Trout & <br/>Wild Herbs</span></h1>
              <h6 className="f-lora-i lh-base mb-4 mb-sm-5" variants={textAnimate}>A rustic, fire-based version on a classic Scottish dish. Cullen Skink is a speciality from the north-east corner of Scotland, originating in Cullen, just up the coast in Moray.</h6>
            </motion.div>
            <p className="f-lora fw-bold mb-3">Ingredients (serves 4) </p>
            <p className="mb-4 mb-sm-5">2 tbsp of unsalted butter
            <br/>1 medium white onion
            <br/>½ clove of garlic
            <br/>4 medium sized potatoes, diced
            <br/>1 wild brown trout fillet
            <br/>1 smoked haddock fillet
            <br/>250ml of organic milk
            <br/>60ml of organic cream
            <br/>Small handful of spinach (optional)
            <br/>Wild herbs (if available) 
            <br/>Salt & pepper to taste </p>

            <p className="f-lora fw-bold mb-3">Method </p>
            <p className="mb-2">Prepare a fire and let it burn down until you have a bed of hot, glowing embers.</p>
            <p className="mb-2">Place an iron grill over the embers and refuel the fire to increase the heat. </p>
            <p className="mb-4 mb-sm-5">Carefully lift the cast iron onto the grill and add the butter. Whilst the butter
            begins to melt, finely chop the white onion and garlic. When the butter begins
            to sizzle, add the onions and cook until soft - around five minutes. Add in the
            garlic and cook for a further four minutes, stirring occasionally. Leaving the skin
            on, finely dice the potatoes and add them to the pan and cook for one minute
            before pouring in the milk. Place a lid over the cast iron pan and simmer for ten
            minutes, stirring occasionally. Whilst the potatoes are simmering, roughly slice
            the trout and smoked haddock. When the potatoes are nice and soft, add the
            fish and cream and cook for five minutes. When the fish is beautifully soft and
            tender, add the remaining ingredients and season with salt and pepper to taste.
            Garnish with wild herbs of your choice and enjoy eating in the open air.</p>
          </div>

        </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article8;
